import { OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { DagSourceModel } from "@app/workflow-common/services/DagSourceModel";
import { TriggerDatasetService } from "@app/workflow-common/services/trigger-dataset.service";
var ConditionalEdgeComponent = /** @class */ (function () {
    function ConditionalEdgeComponent(triggerService, _formBuilder) {
        this.triggerService = triggerService;
        this._formBuilder = _formBuilder;
        this.isReadOnlyMode = false;
        this.select2Instance = null;
        this.isEdit = false;
        this.dataFunction = function (item) { return item.text; };
        this.activeConditionalField = undefined;
        this.operators = {};
    }
    ConditionalEdgeComponent.prototype.ngOnInit = function () {
        var fields = this.dagSourceModel.getFieldMetadata();
        var formData = {
            operator: '',
            value: ''
        };
        var condition = this.blockObject.condition;
        if (condition) {
            this.isEdit = true;
            formData.operator = condition['operator'];
            formData.value = condition['value'];
        }
        this.activeConditionalField = fields[this.conditionalColName];
        this.operators = this.triggerService.getOperators();
        this.conditionForm = this.formGroup();
        this.conditionForm.addControl('operator', new FormControl(formData.operator, [Validators.required]));
        this.conditionForm.addControl('value', new FormControl(formData.value, [Validators.required]));
        this.conditionForm.addControl('col_name', new FormControl(this.conditionalColName));
        this.conditionForm.addControl('text', new FormControl(this.activeConditionalField['text']));
        this.conditionForm.addControl('type', new FormControl(this.activeConditionalField['type']));
        this.conditionForm.addControl('fieldType', new FormControl(this.activeConditionalField['fieldType']));
        this.conditionForm.addControl('pageType', new FormControl(this.activeConditionalField['pageType']));
    };
    ConditionalEdgeComponent.prototype.formGroup = function () {
        return this.form.get('condition');
    };
    ConditionalEdgeComponent.prototype.onSelectOperator = function () {
        var formGroup = this.formGroup();
        formGroup.get('value').setValue('');
        if (this.select2Instance) {
            this.select2Instance.select2('destroy');
        }
    };
    ConditionalEdgeComponent.prototype.onSelectMultipleSelect = function (event) {
        this.formGroup().get('value').setValue(event);
    };
    ConditionalEdgeComponent.prototype.setSelect2Instance = function ($instance) {
        this.select2Instance = $instance;
    };
    return ConditionalEdgeComponent;
}());
export { ConditionalEdgeComponent };
